import { Link, Outlet } from 'react-router-dom';
import { useRef } from 'react';
import logo from './terrapene.png';
import './Layout.css';

function Layout() {
  const mobileNavRef = useRef(null);

  const handleNavClick = () => {
    if (mobileNavRef.current) {
      mobileNavRef.current.removeAttribute('open');
    }
  };

  return (
    <div className="App">
      <header className="site-header">
        <div className="header-top">
          <img src={logo} alt="Terrapene Logo" />

          <div className="header-titles">
            <h1>Terrapene Property Services</h1>
            <h3>Serving Williamson and Travis Counties</h3>
          </div>

          <div className="header-contact">
            <div className="contact-email">
              <a href="mailto:info@terrapenepropertyservices.com" className="contact-link">
                info@terrapenepropertyservices.com
              </a>
            </div>
            <div className="contact-phone">
              <a href="tel:+15128878159" className="contact-link">
                (512) 887-8159
              </a>
            </div>
          </div>
        </div>
      </header>

      {/* Mobile nav toggle */}
      <details className="mobile-nav" ref={mobileNavRef}>
        <summary>☰ Click here to explore our services</summary>
        <SiteNav onClick={handleNavClick} />
      </details>

      <SiteNav />

      <main className="site-content">
        <Outlet />
      </main>

      <footer className="site-footer">
        <div className="footer-rights">
          © 2025 Terrapene Property Services. All rights reserved.
        </div>
      </footer>
    </div>
  );
}

export default Layout;

// Add onClick prop to handle nav closing for mobile
function SiteNav({ onClick }) {
  return (
    <nav className="site-nav">
      <Link to="/" onClick={onClick}>Home</Link>
      <Link to="/services/downsizing" onClick={onClick}>Downsizing & Organizing</Link>
      <Link to="/services/estate-sales" onClick={onClick}>Estate & Moving Sales</Link>
      <Link to="/services/site-cleaning" onClick={onClick}>Site Cleanup</Link>
      <Link to="/services/lawn-care" onClick={onClick}>Lawn & Grounds Maintenance</Link>
    </nav>
  );
}
